import { Sprite } from 'pixi.js';

export class Magnet extends Sprite {
    constructor(size: [number, number]) {
        super();

        const assets = PIXI.utils.TextureCache;
        const frames = [
            assets['boosterfx/booster-magnet-VFX0001'],
            assets['boosterfx/booster-magnet-VFX0002'],
            assets['boosterfx/booster-magnet-VFX0003'],
            assets['boosterfx/booster-magnet-VFX0004'],
            assets['boosterfx/booster-magnet-VFX0005'],
            assets['boosterfx/booster-magnet-VFX0006'],
            assets['boosterfx/booster-magnet-VFX0007'],
            assets['boosterfx/booster-magnet-VFX0008'],
            assets['boosterfx/booster-magnet-VFX0009'],
            assets['boosterfx/booster-magnet-VFX0010'],
            assets['boosterfx/booster-magnet-VFX0011'],
            assets['boosterfx/booster-magnet-VFX0012'],
            assets['boosterfx/booster-magnet-VFX0013'],
            assets['boosterfx/booster-magnet-VFX0014'],
            assets['boosterfx/booster-magnet-VFX0015'],
            assets['boosterfx/booster-magnet-VFX0016'],
            assets['boosterfx/booster-magnet-VFX0017'],
            assets['boosterfx/booster-magnet-VFX0018'],
            assets['boosterfx/booster-magnet-VFX0019'],
            assets['boosterfx/booster-magnet-VFX0020'],
            assets['boosterfx/booster-magnet-VFX0021'],
            assets['boosterfx/booster-magnet-VFX0022'],
            assets['boosterfx/booster-magnet-VFX0023'],
            assets['boosterfx/booster-magnet-VFX0024'],
            assets['boosterfx/booster-magnet-VFX0025'],
            assets['boosterfx/booster-magnet-VFX0026'],
            assets['boosterfx/booster-magnet-VFX0027'],
            assets['boosterfx/booster-magnet-VFX0028'],
            assets['boosterfx/booster-magnet-VFX0029'],
            assets['boosterfx/booster-magnet-VFX0030'],
            assets['boosterfx/booster-magnet-VFX0031'],
            assets['boosterfx/booster-magnet-VFX0032'],
            assets['boosterfx/booster-magnet-VFX0033'],
            assets['boosterfx/booster-magnet-VFX0034'],
            assets['boosterfx/booster-magnet-VFX0035'],
            assets['boosterfx/booster-magnet-VFX0036'],
            assets['boosterfx/booster-magnet-VFX0037'],
            assets['boosterfx/booster-magnet-VFX0038'],
            assets['boosterfx/booster-magnet-VFX0039'],
            assets['boosterfx/booster-magnet-VFX0040'],
        ];

        const anim = new PIXI.extras.AnimatedSprite(frames);
        anim.anchor.set(0.5);
        anim.y = -(size[0] * 0.1);
        anim.animationSpeed = 0.5;
        anim.loop = false;

        const tileBg = new Sprite(PIXI.utils.TextureCache['tile-bg']);
        anim.scale.set((size[0] / tileBg.width) * 2);
        this.addChild(anim);
        tileBg.destroy();

        anim.play();

        anim.onComplete = () => {
            this.destroy();
        };
    }
}
